import React from 'react';

import { Guideline } from '@components/common';

import { guidelineText } from './constants';

import styles from './CollapsibleBlockLabel.module.scss';

interface ICollapsibleBlockLabel {
	label: string;
}

const CollapsibleBlockLabel = ({ label }: ICollapsibleBlockLabel) => {
	return (
		<div className={styles.collapsibleBlockLabel}>
			{label}
			<Guideline
				guidelineText={guidelineText}
				maxWidth={268}
				placement='top'
			/>
		</div>
	);
};

export default CollapsibleBlockLabel;
